import { jsx as o } from "@emotion/react/jsx-runtime";
import { useTheme as n } from "@emotion/react";
import { Icon as m, FontAwesomeIconsPartooUsed as a, IconPrefix as c } from "@partoohub/ui";
import { containerCss as l, BusinessCardImage as d } from "./BusinessCard.styled.js";
import { useIsBusinessSelected as f } from "../../../../hooks/useIsBusinessSelected.js";
import { ImageWithFallback as p } from "../../../../../ImageWithFallback/ImageWithFallback.js";
const B = ({
  business: r
}) => {
  const i = n(), {
    logo_url: e,
    media_mapping: t
  } = r, s = f({
    business: r
  });
  return /* @__PURE__ */ o(p, { resizeImageConfig: {
    url: e,
    urlMapping: t,
    width: 50,
    height: 50,
    fit: "inside"
  }, alt: "Business Card Photo", shouldResize: !0, containerCss: l(i, s), fallback: /* @__PURE__ */ o(d, { url: e, children: !e && !s && /* @__PURE__ */ o(m, { icon: [a.faImage, c.SOLID], iconSize: "24px", color: "secondary" }) }) });
};
export {
  B as BusinessCardPhoto
};
